module.exports = __webpack_public_path__ + "img/全景智联智慧制造ERP系统.4f48f230.jpg";